import React, { useEffect, useRef } from 'react';
import './Members.css';

const Members = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div className="members-page">
      <div className="members-container" ref={sectionRef}>
        <div className="members-content">
          <h1 className="members-title">LOG IN TO CONNECT WITH MEMBERS</h1>
          <p className="members-subtitle">
            View and follow other members, leave comments & more
          </p>
          
          <div className="login-section">
            <button className="login-button">
              Log In
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Members;
